<template>
  <div>
    <div class="desc">
      <div class="quesItem-header">
        <div class="quesItem-type">
          <div class="left">{{ getQuestionType(a.type) }}</div>
          <div class="right" v-if="temp !== 3 && !hide_score && !wrongbook">
            {{ temp === 2 ? avg_score : a.score }}分
          </div>
        </div>
        <div v-if="book_vip">
          <img
            v-if="!a.qid"
            class="handle-icon ml30"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220308/158b6842d5dcbba4ca56d1497c7ac37c.svg"
            @click="edit"
          />
          <img
            class="handle-icon"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220308/7ce41b06f42a480b88481d37418e9016.svg"
            @click="remove"
          />
        </div>
      </div>
      <div
        class="preLine"
        :class="[
          fontIndex ? fontRules['answer'][1] : fontRules['answer'][4],
          single && flod ? 'ellipsis-text' : ''
        ]"
        @click="single ? changeFlod : ''"
      >
        <label class="text-red" v-if="!single && temp == 3 && a.required"
          >*</label
        >
        <label class="sort">
          <label v-if="temp != 6 && !single">{{
            page === 1
              ? index + 1 + "."
              : (page - 1) * pagesize + index + 1 + "."
          }}</label>
        </label>
        <span @touchend="onLongPressEnd(a.desc)">{{ a.desc }}</span>
        <label v-if="single && flod" class="expand-btn">展开</label>
      </div>
    </div>
    <template v-if="!flod && !toggleDetail">
      <div
        class="editRecord"
        v-if="a.change_history && a.change_history.length"
      >
        <div class="editRecord-title">修改得分记录</div>
        <div
          class="editRecord-item"
          v-for="(item, eindex) in a.change_history"
          :key="eindex"
        >
          <div class="editRecord-content">
            {{ item.user_name }} - ({{ item.score }}分 {{ item.t_update }})
          </div>
          <div class="editRecord-reason">
            <span class="preLine">{{ item.reason }}</span>
          </div>
        </div>
      </div>
      <div class="pics" v-if="a.imgs && a.imgs.length">
        <div v-for="(item, eindex) in a.imgs" :key="eindex">
          <img :src="item" mode="widthFix" @click="showPic(item)" />
        </div>
      </div>
      <div class="videos" v-if="a.videos && a.videos.length">
        <div v-for="(item, eindex) in a.videos" :key="eindex">
          <video
              v-if="a.videoAble"
              :src="item.url"
              class="videos-item"
              controls="controls"
              :poster="item.thumb"
            ></video>
            <img :src="item.url" v-else />
        </div>
      </div>
      <div
        class="discussion"
        :class="fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]"
        v-if="a.type == 4"
      >
        <div class="grey mb20 flexCenterBetween">
          <label
            :class="fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]"
            >{{
              is_my_result
                ? temp == 3
                  ? "我的回答"
                  : "我的答案"
                : temp == 3
                ? "考生回答"
                : "考生答案"
            }}</label
          >
          <scoreitem
            v-if="temp != 3 && !hide_score && !wrongbook"
            :a="a"
            :is_admin="is_admin"
            :is_owner="is_owner"
            @editScore="editScore"
          />
        </div>
        <div class="grey" v-if="a.audit == 1">审核中（通过后正常展示）</div>
        <div class="grey" v-else-if="a.audit == 2">内容违规，已被隐藏</div>
        <div v-else class="short-anser">
          <span
            class="preLine"
            :style="{
              color: !a.discussion
                ? '#999999'
                : a.discussiona && !hide_score
                ? '#00cf97'
                : '#000'
            }"
            v-if="temp == 3"
            >{{ a.discussion ? a.discussion : "未作答" }}</span
          >
          <span v-else class="preLine" :class="!a.discussion ? 'grey' : ''" >{{
            a.discussion ? a.discussion : "未作答"
          }}</span>
          <img
            class="dis-img"
            :src="a.img"
            mode="widthFix"
            @click="showPic(a.img)"
            v-if="a.img"
          />
          <div
            :class="fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]"
            class="short-anser-comment"
            style="margin-top: 5px;"
            v-if="a.type == 4 && (a.score_get == -1 || a.remark)"
          >
            <label
              :class="
                fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]
              "
              style="color:#FE9900"
              v-if="a.score_get != -1 && a.remark"
              >评语</label
            >
            <div
              :class="
                fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]
              "
              @click="showSubDialog()"
              v-if="a.score_get == -1"
              style="color:#FE9900"
            >
              {{
                has_sub
                  ? "简答题批改中，请留意立吉答题公众号批改通知"
                  : "简答题批改中，点击接收批改结果"
              }}
            </div>
            <div
              :class="
                fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]
              "
              v-else
            >
              <span
                class="preLine"
                @click="is_admin || is_owner ? showSubDialog() : ''"
                v-if="a.remark"
                >{{ a.remark }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="options">
        <div
          class="options-copy"
          v-if="a.type == 0 || a.type == 1 || a.type == 2"
        >
          <div
            v-for="(item, eindex) in a.options"
            :key="eindex"
            :class="['option-box', fontIndex ? 'f46' : fontRules['answer'][4]]"
          > 
            <div class="option">
              <div v-if="temp !== 6">
                <img
                  :src="rightIcon"
                  :class="fontIndex ? '' : 't2'"
                  v-if="
                    (item.right === 1 &&
                      item.check === 1 &&
                      !hide_score && showAnswer) ||
                      (temp === 3 && item.check === 1)
                  "
                />
                <img
                  :src="wrongIcon"
                  :class="fontIndex ? '' : 't2'"
                  v-else-if="
                    item.right === 0 &&
                      item.check === 1 &&
                      !hide_score && showAnswer
                  "
                />
                <div
                  class="letter"
                  v-else
                  :style="{
                    color:
                      item.right === 1 &&
                      !hide_score && showAnswer
                        ? '#00cf97'
                        : ''
                  }"
                >
                  {{ item.letter }}
                </div>
              </div>
              <div class="view" v-if="(!showAnswer || hide_score) && temp != 3">
                <span class="preLine">{{ item.content }}</span>
              </div>
              <div v-else class="flexCenter">
                <span
                  class="view preLine"
                  :style="{
                    color:
                      item.right === 1 || (temp === 3 && item.check === 1)
                        ? '#00cf97'
                        : item.check === 1
                        ? '#ff7070'
                        : ''
                  }"
                  >{{ item.content }}</span
                ><label class="score-item" v-if="item.score >= 0 && !hide_score && temp == 3">{{item.score}}分</label>
              </div>
            </div>
            <div class="other-fill" :class="item.blank_input ? '' : 'grey'" v-if="temp == 3 && item.other && item.check">{{item.blank_input || '未填写'}}</div>
          </div>
        </div>
        <div v-if="a.type === 3 && temp === 3">
          <div
            v-if="a.audit === 1"
            class="row-box grey"
            style="padding-top: 5px"
          >
            审核中（通过后正常展示）
          </div>
          <div
            v-else-if="a.audit === 2"
            class="row-box grey"
            style="padding-top: 5px"
          >
            内容违规，已被隐藏
          </div>
          <template v-else>
            <div
              class="option fillBox"
              :class="[
                fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]
              ]"
              v-for="(item, eindex) in a.options"
              :key="eindex"
            ><span class="minW80" :class="{minW120: fontIndex}">空{{ eindex * 1 + 1 }}：</span><span class="preLine">{{item.blank_input}}</span>
            </div>
          </template>
        </div>
        <div v-if="temp != 3">
          <div
            :class="[
              a.type == 3 ? 'pb30' : 'answer',
              fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]
            ]"
            v-if="a.type != 4 && a.type != 5"
          >
            <!-- 答案非填空 -->
            <div v-if="a.type == 0 || a.type == 1 || a.type == 2">
              <div class="row-box uFlexCenterBetween">
                <div :class="wrongbook ? 'amin-height' : ''">
                  <label style="color:#999">{{ is_my_result ? "我的" : "考生" }}答案：</label><label
                    :style="{
                      color:
                        hide_score || !showAnswer
                          ? '#333'
                          : a.right == 1
                          ? '#00cf97'
                          : '#ff7070'
                    }"
                    v-if="a.your_answer"
                  >{{ a.your_answer }}</label>
                  <label style="color:#999" v-else>未作答</label>
                </div>
                <scoreitem
                  v-if="temp != 3 && !hide_score && !wrongbook"
                  :a="a"
                  :is_admin="is_admin"
                  :is_owner="is_owner"
                  @editScore="editScore"
                />
              </div>
              <div
                v-if="!showAnswer"
                class="row-box"
              >
                <label style="color:#999">正确答案：</label><label class="grey">出题人设置隐藏</label>
              </div>
              <div v-else class="row-box" style="color:#999"><label>正确答案：</label><label>{{ a.correct ? a.correct : "无" }}</label></div>
            </div>

            <!-- 答案（填空） -->
            <div v-if="a.type == 3">
              <div
                v-if="a.audit == 1"
                class="row-box grey"
                style="padding-top: 5px"
              >
                审核中（通过后正常展示）
              </div>
              <div
                v-else-if="a.audit == 2"
                class="row-box grey"
                style="padding-top: 5px"
              >
                内容违规，已被隐藏
              </div>
              <template v-else>
                <div class="flexCenterBetween mb20">
                  <label
                    class="grey"
                    :class="
                      fontIndex
                        ? fontRules['answer'][3]
                        : fontRules['answer'][2]
                    "
                  >
                    {{ is_my_result ? "我的" : "考生" }}答案
                  </label>
                  <scoreitem
                    v-if="temp != 3 && !hide_score && !wrongbook"
                    :a="a"
                    :is_admin="is_admin"
                    :is_owner="is_owner"
                    @editScore="editScore"
                  />
                </div>

                <!-- 不展示正确答案只展示我的答案 -->
                <div
                  v-if="!showAnswer"
                  class="fillBlank-single"
                >
                  <div
                    v-for="(m, eindex) in a.options"
                    :key="eindex"
                    class="fillBox"
                  >
                    <span class="minW80" :class="{minW120: fontIndex}">空{{ eindex * 1 + 1 }}：</span><span
                      class="preLine"
                      :class="
                        !m.blank_input
                          ? 'grey'
                          : hide_score || !showAnswer
                          ? ''
                          : m.right
                          ? 'green'
                          : 'red'
                      "
                    >{{ m.blank_input ? m.blank_input : "未作答" }}</span>
                  </div>
                </div>

                <!-- 展示我的答案及正确答案 -->
                <div v-else class="fillBlank">
                  <div
                    v-for="(m, eindex) in a.options"
                    :key="eindex"
                    class="fillBox"
                  >
                    <div class="row-box">
                      <span class="minW80" :class="{minW120: fontIndex}">空{{ eindex * 1 + 1 }}：</span>
                      <span
                        class="preLine"
                        :class="
                          !m.blank_input
                            ? 'grey'
                            : hide_score
                            ? ''
                            : m.right
                            ? 'green'
                            : 'red'
                        "
                      >{{ m.blank_input ? m.blank_input : "未作答" }}
                      </span>
                    </div>
                  </div>
                  <div
                    style="color: #999; margin-bottom: 5px; margin-top: 15px;"
                    :class="
                      fontIndex
                        ? fontRules['answer'][3]
                        : fontRules['answer'][2]
                    "
                  >
                    正确答案{{ a.order_answer ? "-无顺序" : "" }}
                  </div>
                  <!-- wrong -->
                  <div v-for="(m, sindex) in a.options" :key="m.id">
                    <div style="color: #262626;" class="row-box pt10">
                      空{{ sindex * 1 + 1 }}：
                      <label v-for="(t, idx) in m.blank" :key="idx">
                        <label class="blank-item preLine">
                          <label class="blank-text grey" v-if="idx > 0"
                            >或</label
                          >
                          <span>{{ t }}</span>
                        </label>
                      </label>
                    </div>
                  </div>
                  <!-- wrong -->
                </div>
                <div
                  class="grey"
                 :class="fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]"
                  v-if="!showAnswer"
                  style="padding-top: 5px"
                >
                  <label>正确答案</label>
                  <div style="margin-top: 5px;">出题人设置隐藏</div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div
          v-if="temp !== 3 && temp !== 6 && !single"
          :class="fontIndex ? fontRules['answer'][3] : fontRules['answer'][2]"
        >
          <div
            :class="show_answer === 3 ? 'analysis' : ''"
            :style="a.type === 4 ? 'margin-top: 20px;' : ''"
          >
            <label class="grey">解析</label>
          </div>
          <div
            v-if="hideAnly"
            class="grey mt5"
          >
          出题人设置隐藏
          </div>
          <div v-else class="analysis-text">
            <span class="preLine">{{
              a.answer ||
              a.parsing_imgs.length ||
              (a.parsing_items && a.parsing_items.length)
                ? a.answer
                : wrongbook && !a.ai_parse && a.type !== 5 && showAiAnly
                ? ""
                : "无"
            }}</span>
            <template
              v-if="
                showAiAnly &&
                  wrongbook &&
                  !single &&
                  a.type !== 5
              "
            >
              <div v-if="a.ai_parse" class="ai-content">
                <img
                  class="ai-title"
                  src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-07-01/40cf08ed354b4b4d3fc77134e27e21ca.png"
                  mode="aspectFit"
                />
                <label class="ai-title-behind">:</label>
                <label class="ai-result">{{ a.ai_parse }}</label>
                <label
                  class="ai-see-more expand-btn expand-btn-long"
                  @click="toAi(a, index, a.bid)"
                  >查看全部</label
                >
              </div>
              <div
                v-else
                :class="a.audit_status ? 'grey' : 'ai-see-more'"
                @click="a.audit_status ? null : toAi(a, index, a.bid)"
              >
                {{ a.audit_status ? "无" : "点击查看参考解析>" }}
              </div>
            </template>
            <div style="margin-top: 7px">
              <gzhfile :fileLists="a.parsing_items || []" />
            </div>
            <template v-if="a.parsing_imgs && a.parsing_imgs.length">
              <div
                class="pics"
                v-for="(item, sindex) in a.parsing_imgs"
                :key="sindex"
              >
                <img :src="item" mode="widthFix" @click="showPic(item)" />
              </div>
            </template>
          </div>
        </div>
        <div class="infos" v-if="wrongbook && !single">
          <div class="infos-item">错题来源：{{ a.title }}</div>
          <div class="infos-item">加入时间：{{ a.join_time }}</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
// 换行处理 禁止一键格式化
import { font_rules } from "@/utils/config";
import scoreitem from "./scoreitem.vue";
import gzhfile from "../gzhfile.vue";
import { ImagePreview } from "vant";
import { isMobile } from "@/utils/common";
import { Toast } from "vant";


export default {
  props: {
    a: {
      type: Object,
      default: {}
    },
    show_answer: {
      type: Number,
      default: 0
    },
    has_sub: {
      type: Number,
      default: 0
    },
    temp: {
      type: Number,
      default: 0
    },
    avg_score: {
      type: Number,
      default: 0
    },
    fontIndex: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    is_admin: {
      type: Number,
      default: 0
    },
    is_owner: {
      type: Number,
      default: 0
    },
    hide_score: {
      type: Number,
      default: 0
    },
    is_my_result: {
      type: Number,
      default: 0
    },
    wrongbook: {
      type: Number,
      default: 0
    },
    book_vip: {
      type: Number,
      default: 0
    },
    pagesize: {
      type: Number,
      default: 0
    },
    single: {
      type: Boolean,
      default: false
    },
    flod: {
      type: Boolean,
      default: false
    },
    toggleDetail: {
      type: Boolean,
      default: false
    },
    copy_able: {
      type: Number,
      default: false
    }
  },
  data() {
    return {
      showAnswer: false,
      hideAnly: false,
      showAiAnly: false,
      isMobile: isMobile(),
      fontRules: font_rules,
      rightIcon:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/716f21db42900bb102215d266cf68f2f.png",
      wrongIcon:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/383c6d88369edf3e96a4867314715314.png"
    };
  },
  methods: {
    onLongPressEnd(desc) {
      if(this.book_vip || this.copy_able) {
        this.$copyText(desc);
        Toast("复制成功");
      }
    },
    edit(item) {
      this.$emit("handleWrongClick", item);
    },
    remove(item) {
      this.$emit("handleWrongClick", item);
    },
    editScore(item) {
    },
    showSubDialog() {
      if (this.has_sub) return;
      let url = 'https://mp.weixin.qq.com/s/j9hHKHMYCZDZmulLZzql5w'
      if(this.isMobile) {
        window.location.href = url;
      }else {
        window.open(url)
      }
    },
    showPic(val) {
      ImagePreview({
        images: [val],
        showIndex: false,
        loop: false,
        startPosition: 0
      });
    },
    toAi(item) {
      this.$emit("handleWrongClick", item);
      // this.$emit("toAi", item);
    },
    changeFlod() {
      // this.$emit("changeFlod");
    },
    getQuestionType(type) {
      switch (type) {
        case 0:
          return "单选题";
        case 1:
          return "多选题";
        case 2:
          return "判断题";
        case 3:
          return "填空题";
        case 4:
          return "简答题";
        case 5:
          return "图片题";
        default:
          return "";
      }
    }
  },
  mounted (){
    let { show_answer } = this;
    if(show_answer != 4 && show_answer != 3  && show_answer != 1 && show_answer != 6) {
      this.showAnswer = true; 
    }
    if(show_answer == 1 || show_answer == 2 || show_answer == 4) {
      this.hideAnly = true
    }
    if(show_answer == 0 || show_answer == 3) {
      this.showAiAnly = true;
    }
  },
  components: { scoreitem, gzhfile }
};
</script>
<style lang="scss" scoped>
.desc {
  padding: 0 0 10px;
  font-size: 15px;
}

.quesItem-type {
  height: 20px;
  padding: 0 7.5px;
  font-size: 12px;
  background: rgba(24, 144, 255, 0.1);
  border-radius: 10px;
  color: #1890ff;
  display: inline-flex;
  align-items: center;
}

.quesItem-type .left {
  font-size: 12px;
  color: #1890ff;
  display: flex;
}
.quesItem-type .right {
  margin-left: 7.5px;
}
.text-red {
  color: #ff5c5c !important;
  padding-right: 2px;
}
.sort {
  color: #999999;
}
.editRecord {
  background: #f8f8f8;
  border-radius: 2px;
  color: #999999;
  font-size: 13px;
  line-height: 19.5px;
  padding: 10px;
  margin-bottom: 15px;
}

.editRecord-item {
  margin-bottom: 5px;
}
.editRecord-item:last-child {
  margin-bottom: 0;
}

.pics {
  margin: 5px 0 10px;
}

.pics img,
.videos img {
  width: 100%;
  object-fit: cover;
}

.videos {
  margin: 5px 0 15px;
}

.videos .videos-item {
  width: 100%;
}
video {
  height: 225px;
}

.discussion .dis-img {
  width: 100%;
  margin-top: 5px;
}

.grey {
  color: #999;
  padding-right: 5px;
}

.view.grey {
  font-size: 14px;
}
.mb20 {
  margin-bottom: 10px;
}

.short-anser {
  background: #fafafa;
  padding: 10px;
  border-radius: 4px;
}
.short-anser-comment {
  background: #fafafa;
}
.pt10 {
  padding-top: 5px;
}
.pb30 {
  padding-bottom: 15px;
}

.option {
  display: flex;
  display: -webkit-flex;
  // font-size: 15px;
  align-items: baseline;
}
.option-box {
  margin-bottom: 10px;
}
.option-box:last-child {
  margin-bottom: 0;
}
.option:last-child {
  margin-bottom: 0;
}

.option img,
.letter {
  width: 15px;
  height: 15px;
  min-width: 15px;
  margin-right: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.option img {
  position: relative;
}
.t2 {
  top: 2px;
}

.option .view {
  flex: 1;
}

.row-box {
  display: flex;
  align-items: baseline;
}

.answer {
  font-size: 15px;
}

.answer:last-child {
  padding-top: 15px;
  padding-bottom: 15px;
}

.analysis {
  // margin-bottom: 5px;
}
.answer .red {
  color: #ff5c5c;
}

.analysis-text {
  padding-top: 5px;
}

.fillBlank > .view {
}

.fillBlank > .view:last-child {
  margin-bottom: 0;
}

.fillBlank-single {
  margin: 10px 0;
}
.green {
  color: #00cf97;
}
.fillBlank-single .view {
  line-height: 25px;
}
.fillBox {
  background-color: #fafafa;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  margin-bottom: 10px;
  padding: 10px;
  align-items: center;
}

.blank-text {
  padding: 0 10px;
}
.uFlexCenterBetween,
.flexCenterBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f28 {
  font-size: 14px !important;
}
.f30 {
  font-size: 15px !important;
}
.f48 {
  font-size: 24px !important;
}
.f44 {
  font-size: 22px !important;
}
.f32 {
  font-size: 16px !important;
}
.f46 {
  font-size: 23px !important;
}

.infos {
  background: #f8f8f8;
  padding: 10px;
  font-size: 14px;
  line-height: 21px;
  color: #666666;
  margin-top: 10px;
}

.infos .infos-item:first-child {
  margin-bottom: 5px;
}
.handle-icon {
  width: 18px;
  height: 18px;
  margin-left: 15px;
}
.quesItem-header {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ai-content {
  background: #f7fbff;
  height: 41px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 10px;
  font-size: 14px;
  box-sizing: border-box;
  position: relative;
  margin-top: 10px;
}
.ai-title-behind {
  color: #1890ff;
  font-weight: bold;
}

.ai-title {
  width: 58.5px;
  height: 21px;
  object-fit: contain;
}
.ai-result {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 160.5px;
  margin-left: 5px;
}
.ai-see-more {
  color: #1890ff;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}
.expand-btn {
  position: absolute;
  right: 0;
  z-index: 3;
  width: 78.5px;
  height: 21.5px;
  text-align: right;
  color: #1890ff;
  background: linear-gradient(
    270deg,
    #ffffff 0%,
    #ffffff 54%,
    rgba(255, 255, 255, 0) 100%
  );
}
.expand-btn-long {
  width: 120px;
  height: 31px;
  line-height: 31px;
  background: linear-gradient(
    270deg,
    #f7fbff 0%,
    #f7fbff 54%,
    rgba(255, 255, 255, 0) 100%
  );
  padding-right: 10px;
}

.green {
  color: #00cf97;
}

.red {
  color: #ff5c5c;
}
.amin-height {
  min-height: 29px;
  line-height: 29px;
}
.minW80{
  min-width: 40px;
}
.minW120{
  min-width: 60px;
}
.mt5 {
  margin-top: 5px;
}
.score-item {
  padding: 0 5px;
  height: 17px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  background: #D6F4E7;
  color: #00CF97;
  font-size: 12px;
  border-radius: 2px;
}

.other-fill {
  background: #FAFAFA;
  height: 40px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  margin-top: 10px;
  border-radius: 4px;
}
</style>




// WEBPACK FOOTER //
// src/components/common/qItem.vue